(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bto-home-hero"] && !Shopify.designMode) return;
  try {
    
  function initializeBtoScrollReveals() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = document.querySelectorAll('.bto-portfolio__intro, .bto-portfolio__card, .bto-portfolio__contact, .bto-about__visual, .bto-about__copy');
    if (!targets.length) return;
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bto-reveal--visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px 30px 0px' });
    targets.forEach((target) => {
      if (target.classList.contains('bto-reveal')) return;
      target.classList.add('bto-reveal');
      observer.observe(target);
    });
    document.documentElement.classList.add('bto-motion-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBtoScrollReveals, { once: true });
  } else {
    initializeBtoScrollReveals();
  }
  document.addEventListener('shopify:section:load', initializeBtoScrollReveals);
  document.addEventListener('shopify:section:select', (event) => {
    event.target.querySelectorAll('.bto-reveal').forEach((target) => target.classList.add('bto-reveal--visible'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
